'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: [{ required: true, message: '此项必填', trigger: 'blur' }],
  pictureID: [{ required: true, message: '此项必填', trigger: 'blur' }]
};